// extracted by mini-css-extract-plugin
export default {"popup":"errorPopup_popup__5e4Aj","popup__title":"errorPopup_popup__title__IwbFw","popup__img":"errorPopup_popup__img__xx4Aa","popup__nextBtn":"errorPopup_popup__nextBtn__HZhgz"};